import { render, staticRenderFns } from "./BInputNumber.vue?vue&type=template&id=2a0f9332"
import script from "./BInputNumber.vue?vue&type=script&lang=js"
export * from "./BInputNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports